import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { Tenant } from '@jerico/shared';

// --- Tenant ---

export function useTenant() {
  return useQuery({
    queryKey: ['tenant'],
    queryFn: () => api.get<Tenant>('/tenants/me'),
  });
}

export function useUpdateTenant() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<Tenant>) => api.put<Tenant>('/tenants/me', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tenant'] }),
  });
}
